import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';
import { ConfigService } from 'src/providers/config/config.service';
import { AppEventsService } from 'src/providers/app-events/app-events.service';
import { PawnDataService } from 'src/providers/pawn-data/pawn-data.service';
import { FacturaPage } from '../modals/factura/factura.page';
import { LoginPage } from '../modals/login/login.page';

@Component({
  selector: 'app-pawn-query',
  templateUrl: './pawn-query.page.html',
  styleUrls: ['./pawn-query.page.scss'],
})
export class PawnQueryPage implements OnInit {

  Credentials: any = { mail: '', password: '' };
  userLogged = false;

  constructor(
    public navCtrl: NavController,
    public shared: SharedDataService,
    public config: ConfigService,
    public appEventsService: AppEventsService,
    private pawnServ: PawnDataService,
    private modalCtrl: ModalController
  ) {


  }

  ngOnInit() {
    this.checkLogin();
  }

  async checkLogin() {
    if (this.shared.customerData.customers_id == null || this.shared.customerData.customers_id == undefined) {
      let modal = await this.modalCtrl.create({
        component: LoginPage,
        componentProps: {
          'hideGuestLogin': true
        }
      });
      await modal.present();
    }
    else {

      if (this.shared.customerData.document != '')

        this.cargarFacturas(this.shared.customerData.document);
    }
  }


  /*
   Consulta de empeño
 */

  cargarFacturas(documento) {
    this.pawnServ.facturas(documento)
      .subscribe(
        (data) => { // Success
 
          this.pawnServ.listaFacturas = data['facturas'];
        },
        (error) => {
          console.log(error);
        }
      )
  }


  async facturaClick(item) {

    let modal = await this.modalCtrl.create({
      component: FacturaPage,
      componentProps: { factura: item }
    });

    return await modal.present();
  }

  
  goHome() {
    this.navCtrl.navigateBack (this.config.getCurrentHomePage());
 }

 
}
